var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.headline1) + ": ")]),
              _vm._v(" "),
              _vm.link1
                ? _c("a", { attrs: { href: _vm.link1 } }, [
                    _vm._v(_vm._s(_vm.content1))
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.content1))])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.headline2) + ": ")]),
              _vm._v(" "),
              _vm.link2
                ? _c("a", { attrs: { href: _vm.link2 } }, [
                    _vm._v(_vm._s(_vm.content2))
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.content2))])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.headline3) + ": ")]),
              _vm._v(" "),
              _vm.link3
                ? _c("a", { attrs: { href: _vm.link3 } }, [
                    _vm._v(_vm._s(_vm.content3))
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.content3))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3" }, [
        _c("div", { staticClass: "d-flex content-wrapper__center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", [
            _c("p", [_c("strong", [_vm._v(_vm._s(_vm.headline4))])]),
            _vm._v(" "),
            _c("p", [
              _c("a", { attrs: { href: _vm.link4 } }, [
                _vm._v(_vm._s(_vm.content4))
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-lg-4 d-flex align-items-center justify-content-end"
        },
        [
          _c("a", { staticClass: "faq", attrs: { href: _vm.buttonLink } }, [
            _vm._m(2),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.buttonText))])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-container mr-3" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/service-box-icon-1.svg",
          alt: "Message icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-container mr-3" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/service-box-icon-2.png",
          alt: "WhatsApp icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: {
          src:
            "https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/question-mark-icon.svg",
          alt: "Question mark icon"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }